module.exports = __webpack_public_path__ + "static/Alpha-Regular-c68e2306b05b2948d221b67b8b31aa14.woff";